import * as Customers from '../services/Customers'

export const RECEIVE_CUSTOMERS = 'RECEIVE_CUSTOMERS'
export const RECEIVE_CUSTOMER = 'RECEIVE_CUSTOMER'

function receiveCustomers(query, customers) {
  return {
    type: RECEIVE_CUSTOMERS,
    query,
    customers,
  }
}

export const fetchCustomers = (query) => (dispatch) => {
  Customers.searchCustomers(query).then((data) => dispatch(receiveCustomers(query, data)))
}

function receiveCustomer(customer) {
  return {
    type: RECEIVE_CUSTOMER,
    customer: customer ? customer : { id: -1 },
  }
}

export const fetchCustomer = (id) => (dispatch) => {
  Customers.getCustomer(id).then((data) => dispatch(receiveCustomer(data)))
}
